export default class ProjectDataSectionTranslations {
    constructor(translation) {
        const { id, skills_title, skills_items } = translation;
        this.id = id;
        this.skills_title = skills_title;
        this.skills_items = skills_items;
    }
}
